import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Step,
  StepHeading,
  StepContent,
  Textarea,
  Button,
} from 'prospect-path-components';
import ErrorText from '../../ErrorText';

export default class AdditionalNotesStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        notes: '',
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleNextButtonClicked = this.handleNextButtonClicked.bind(this);
  }
  componentWillMount() {
    const { plan } = this.props;

    if (plan) {
      const { notes } = plan;
      const { data } = this.state;

      data.notes = notes;

      this.setState({ data });
    }
  }
  handleChange(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data[name] = value;

    this.setState({ data });
  }
  handleNextButtonClicked() {
    this.props.onNextButtonClicked({ ...this.state.data });
  }
  errorsForField(field) {
    if (this.props.errors[field]) {
      return this.props.errors[field].map(error => <ErrorText>{error}</ErrorText>);
    }

    return '';
  }
  render() {
    return (
      <Step>
        <StepHeading number={3} disabled={this.props.disabled}>
          Additional Notes
        </StepHeading>
        <StepContent isOpened={this.props.isOpened}>
          {this.errorsForField('notes')}
          <Textarea
            name="notes"
            rows={3}
            placeholder="Any additional information"
            value={this.state.data.notes}
            onChange={this.handleChange}
            disabled={this.props.readOnly}
          />

          <div style={{ marginTop: '1.25rem' }}>
            <Button
              color="primary"
              size="lg"
              onClick={this.handleNextButtonClicked}
            >
              Confirm Pricing Plan
            </Button>
          </div>
        </StepContent>
      </Step>
    );
  }
}

AdditionalNotesStep.propTypes = {
  isOpened: PropTypes.bool,
  disabled: PropTypes.bool,
  onNextButtonClicked: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

AdditionalNotesStep.defaultProps = {
  isOpened: false,
  disabled: true,
  readOnly: false,
};
